<script setup>
import ImgMedia from '@/Components/Images/ImgMedia.vue';
import LinkArrow from '@/Components/LinkArrow.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps({
    type: Object,
    href: [String, null],
    aspectRatio: {
        type: String,
        default: 'aspect-ratio: 1 / 1;',
    },
});
</script>

<template>
    <LinkArrow
        v-if="type"
        :title="type.page_title"
        :href="href"
        white
        :link-title="t('Read more')"
        :job_position="type.job_position"
        :phone="type.phone"
        :email="type.email"
        :excerpt="type.excerpt"
        class="group"
    >
        <div
            :style="aspectRatio"
            class="relative overflow-hidden rounded-t-xl"
        >
            <ImgMedia
                v-if="type.image"
                :media="type.image"
                :sizes="{ default: '100vw', '(min-width: 768px)': '600px' }"
                :classes="'absolute inset-0 object-cover w-full h-full transition-transform duration-300'"
                :class="{ 'group-hover:scale-[1.1]': href }"
            />
        </div>
    </LinkArrow>
</template>
